import { AxiosResponse } from 'axios';
import { ICity } from "../types/dictionaries.types";
import api from 'utils/apiClient';

export const loadCities = (): Promise<AxiosResponse<ICity[]>> => {
  return api.get('/cities');
};
